// SPDX-License-Identifier: MIT

// The live, in-memory consent state, kept in sync by ConsentManager every time
// consent is applied (on load and on every change). This is what the useConsent
// hook and getConsentState() read, so a site can gate its own scripts by category
// without knowing the namespace or reading the cookie itself.
//
// CONSENT_EVENT is dispatched on window on every apply; consumers subscribe to it
// to re-check getConsentState(). Kept in its own module (no React, no DOM) so both
// the component and the hook can import it without a circular dependency.

const CONSENT_EVENT = 'cookieconsentchange';

let current = {};

// Replaces the current { [categoryId]: boolean } map. Called by ConsentManager.
const setConsentState = (states) => {
  current = { ...(states || {}) };
};

// The current { [categoryId]: boolean } map (empty on the server / before mount).
const getConsentState = () => current;

module.exports = { CONSENT_EVENT, setConsentState, getConsentState };
